import { useContext } from 'react'
import { Button, errorToast, toast } from '@/components/ui'
import { LoginContext } from '@/lib/auth'
import { $api, BACKEND_URL } from '@/lib/fetch'
import { prettyBytes, prettyTimestamp } from '@/lib/helpers'

// downloadProfile fetches the file with the admin Bearer token, then triggers
// a browser download via an object URL. We can't just use a plain <a href>
// because the endpoint is auth-gated.
async function downloadProfile(name: string, sessionToken: string | null) {
  if (!sessionToken) {
    toast({ color: 'danger', title: 'Session expirée' })
    return
  }
  const res = await fetch(`${BACKEND_URL}/api/profiles/${name}`, {
    headers: { Authorization: `Bearer ${sessionToken}` },
  })
  if (!res.ok) {
    let detail: unknown = `HTTP ${res.status}`
    try {
      detail = await res.json()
    } catch {
      /* body may not be JSON */
    }
    errorToast('Téléchargement impossible', detail)
    return
  }
  const blob = await res.blob()
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = name
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(a)
  URL.revokeObjectURL(url)
}

export default function ProfilesList() {
  const sessionToken = useContext(LoginContext)?.user?.token ?? null
  const { isLoading, data, error, isError } = $api.useQuery(
    'get',
    '/api/profiles',
  )

  if (isLoading) {
    return <p style={{ color: 'var(--ink-2)' }}>Chargement des profils…</p>
  }

  if (isError) {
    return (
      <p style={{ color: 'var(--danger)' }}>
        Impossible de récupérer les profils: {JSON.stringify(error)}
      </p>
    )
  }

  return (
    <div className="oumma-table-wrap">
      <table className="oumma-table">
        <thead>
          <tr>
            <th>Nom</th>
            <th>Type</th>
            <th>Date</th>
            <th>Taille</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {(data?.profiles ?? []).map((p) => (
            <tr key={p.name}>
              <td>{p.name}</td>
              <td>{p.kind}</td>
              <td>{prettyTimestamp(p.timestamp_ms)}</td>
              <td>{prettyBytes(p.bytes_size)}</td>
              <td>
                <Button
                  size="sm"
                  variant="primary"
                  onClick={() => downloadProfile(p.name, sessionToken)}
                >
                  Télécharger
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}
